import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { putRequest } from 'src/utils/request';
import messages from 'src/pages/ProjectDetailsPage/messages';

const rejectAllShifts = async ({
  jobUuid,
  userUuid,
  reason,
  shiftDate,
}: {
  jobUuid: string;
  userUuid: string;
  reason: string;
  shiftDate?: string;
}) => {
  const payload = {
    job_application: { reason_code: reason },
    ...(shiftDate ? { filters: { shift_date: shiftDate } } : {}),
  };
  const res = await putRequest(
    API.PUT.rejectAllShifts(jobUuid, userUuid),
    payload,
  );
  return res.data;
};

export const useUpdateRejectAllShifts = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: rejectAllShifts,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.DISPO_TIME_WINDOWS],
      });
      handleSuccess(formatMessage(messages.applicationBulkRejected));
    },
    onError: handleError,
  });
};
